// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import CoeusIcon from "../../assets/coeus-icon.png";

interface Props {
    useDarkMode: boolean;
}

export const AnswerIcon = ({ useDarkMode }: Props) => {
    return (
        <img
            style={{ filter: useDarkMode ? 'invert(100%)' : 'none' }}
            src={CoeusIcon}
            width="50px"
            aria-hidden="true"
            aria-label="Answer logo" />
    )
};